import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'OrganizedUnit/GetAllDirectionsOU', method: 'POST', body: filter, token: token })
}
